import { BuilderContent } from '@builder.io/react';
import { FC } from 'react';

import BusinessButton from '@/components/business-button/business-button';
import { COLORS } from '@/components/business-button/business-button.constants';

import styles from './business-sign-up-button.module.scss';

interface Props {
    isMobile?: boolean;
    signupLink?: string;
    page?: any;
}

export const BusinessSignUpButton: FC<Props> = (props) => {
    const { page, signupLink, isMobile } = props;

    return (
        <BuilderContent model="business-hub" content={page}>
            {(variant) => (
                <BusinessButton
                    link={variant?.signupLink ?? signupLink}
                    target="_blank"
                    className={styles.container}
                    buttonText={isMobile ? 'Sign-up' : 'Business sign-up'}
                    autoMargin={false}
                    color={COLORS.BLACK}
                />
            )}
        </BuilderContent>
    );
};
